import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbarr from "./components/Navbarr";
import About from "./components/About";
import Courses from "./components/Courses";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Register from "./components/Register";
import CourseDetail from "./components/CourseDetail";
import Home from "./components/Home";
import ManagerLogin from "./components/ManagerLogin";
import EmployeeLogin from "./components/EmployeeLogin";
import StudentRegister from "./components/StudentRegister";
import EmployeeRegister from "./components/EmployeeRegister";
import StudentDashboard from "./components/StudentDashboard";
import VerifyOTP from "./components/VerifyOtp";
import PrivacyPolicy from "./components/PrivacyPolicy";
import EmployeeDashboard from "./components/EmployeeDashboard";
import CourseCategory from "./components/CourseCatergory";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbarr />

        {/* 👇 This wrapper ensures content starts BELOW navbar */}
        <div className="page-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />

            {/* Courses listing */}
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:category" element={<CourseCategory />} />
            <Route path="/course/:slug" element={<CourseDetail />} />

            {/* Course detail extra URLs */}
            <Route path="/course-detail" element={<CourseDetail />} />
            <Route path="/course-detail/:courseId" element={<CourseDetail />} />
            <Route path="/courseDetail" element={<CourseDetail />} />
            <Route path="/courses/:id" element={<CourseDetail />} />

            {/* Auth pages */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Other logins/registers */}
            <Route path="/ManagerLogin" element={<ManagerLogin />} />
            <Route path="/EmployeeRegister" element={<EmployeeRegister />} />
            <Route path="/EmployeeLogin" element={<EmployeeLogin />} />
            <Route path="/StudentRegister" element={<StudentRegister />} />
            <Route
              path="/StudentDashboard/:id"
              element={<StudentDashboard />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/verify-otp/:userId" element={<VerifyOTP />} />
            <Route path="/EmployeeDashboard" element={<EmployeeDashboard />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
